export function abbreviation(name, length = 3) {
    if (!name) return null;

    return name
        .split(' ')
        .slice(0, length)
        .map(part => part[0])
        .join('')
        .toUpperCase();
}